import React from 'react';

const OfflineMessage = () => (
	<div className="offline">
		You are currently offline. Check your network connection.
	</div>
);

export default OfflineMessage;